<template lang="pug" functional>
img(v-lazy="props.src" v-bind="data.attrs" :key="props.key")
</template>

<script>
export default {
  props: {
    src: { type: String, default: () => '', required: true },
  },
}
</script>
